<section class="masthead-page masthead-partner">
    <p class="card-text montserrat text-center">PARTNER</p>
</section>

<section class="grey mb-5 montserrat">
    <div class="textblock wrapper marginauto">

        <div class="col-11 py-5 marginauto">
            <div class="text text-center pt-3">
                <p class="pb-3">I <strong>Professionisti</strong> della <strong>salute</strong> e del <strong>benessere</strong> dove trovi la massima competenza per protocolli dietetici chetogenici,<br>wellness e antiage in collaborazione diretta con il dottor <strong>Riccardo Ferrero Leone</strong>.</p>

                <span class="font-weight-bold">LAVORA CON NOI</span>
                <p>Se sei un professionista della nutrizione o un'azienda del settore entra nel "<span class="font-weight-bold">Club Professionisti Leone Lifestyle</span>" per accrescere le tue competenze e incrementare la tua attività. Scrivici a <a href="mailto:commerciale@leonelifestyle.com">commerciale@leonelifestyle.com</a>.</p>

            </div>

        </div>
    </div>
</section>

<section class="wrapper marginauto">
    <div class="col-11 mt-3 marginauto">

        <div *ngFor="let partner of partners">

            <div *ngIf="partner.city" class="my-5 montserrat">
                <div class="textblock wrapper marginauto">
                    <div class="divider w-50 marginauto"></div>
                </div>
            </div>

            <div class="textblock my-5  text-xl-left text-lg-left text-md-left text-sm-center text-center">
                <div class="pages-title montserrat">

                    <span *ngIf="partner.city">
                        {{ partner.city }}
                    </span>

                </div>
            </div>

            <div class="row my-3">
                <div class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 text-xl-left text-lg-left text-md-left text-sm-center text-center">
                    <img class="lazyload img-fluid" src="assets/partner/{{ partner.img }}">
                </div>

                <div class="col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12 my-xl-0 my-lg-0 my-md-0 my-sm-5 my-5">
                    <div class="textblock">
                        <div class="pages-title montserrat">
                            <div class="span">{{ partner.name }}</div>
                        </div>

                        <hr/>
                        <p><i class="fa fa-map-marker pr-2" aria-hidden="true"></i>{{ partner.address_1 }}</p>

                        <p *ngIf="partner.address_2">
                            <i class="fa fa-map-marker pr-2" aria-hidden="true"></i>{{ partner.address_2 }}
                        </p>

                        <p *ngIf="partner.info">
                            <i class="fa fa-info-circle pr-2" aria-hidden="true"></i>{{partner.info}}
                        </p>

                        <p><i class="fa fa-phone pr-2" aria-hidden="true"></i>{{ partner.phone }}</p>

                        <p *ngIf="partner.phone_2">
                            <i class="fa fa-phone pr-2" aria-hidden="true"></i>{{ partner.phone_2 }}
                        </p>

                        <p *ngIf="partner.web">
                            <i class="fa fa-globe pr-2" aria-hidden="true"></i>
                            <a href="http://{{partner.web}}" target="_blank">{{partner.web}}</a>
                        </p>

                        <p *ngIf="partner.social_1">
                            <i class="fa fa-facebook pr-2" aria-hidden="true"></i>
                            <a href="http://{{partner.social_1}}" target="_blank">{{ partner.social_1 }}</a>
                        </p>

                        <p *ngIf="partner.social_2">
                            <i class="fa fa-facebook pr-2" aria-hidden="true"></i>
                            <a href="http://{{partner.social_2}}" target="_blank">{{ partner.social_2 }}</a>
                        </p>

                        <p *ngIf="partner.social_3">
                            <i class="fa fa-facebook pr-2" aria-hidden="true"></i>
                            <a href="http://{{partner.social_3}}" target="_blank">{{ partner.social_3 }}</a>
                        </p>

                        <p *ngIf="partner.insta">
                            <i class="fa fa-instagram pr-2" aria-hidden="true"></i>
                            <a href="http://{{partner.insta}}" target="_blank">{{ partner.insta }}</a>
                        </p>

                        <p *ngIf="partner.mail">
                            <i class="fa fa-envelope pr-2" aria-hidden="true"></i>
                            <a href="mailto:{{partner.mail}}">{{partner.mail}}</a>
                        </p>

                        <p *ngIf="partner.mail_1">
                            <i class="fa fa-envelope pr-2" aria-hidden="true"></i>
                            <a href="mailto:{{partner.mail_1}}">{{partner.mail_1}}</a>
                        </p>

                    </div>
                </div>

            </div>

        </div>

    </div>
</section>
